// src/components/ui/ButtonSpinner.jsx
import PropTypes from 'prop-types'
import { RefreshCw } from 'lucide-react'
import { cn } from '../../utils/cn'

const ButtonSpinner = ({ 
  className = '',
  size = 'sm'
}) => {
  const sizeClasses = {
    xs: 'h-3 w-3',
    sm: 'h-3 w-3',
    md: 'h-4 w-4', 
    lg: 'h-5 w-5'
  }

  return (
    <RefreshCw className={cn(
      "animate-spin text-orange-500 mr-1",
      sizeClasses[size],
      className
    )} />
  )
}

ButtonSpinner.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg'])
}

export default ButtonSpinner
